import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table machine register view.
 * @extends JetView
 */
export default class tableMachineRegisterView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox template for displaying approval buttons.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common template properties.
         * @param {string} value - The value to determine checkbox state.
         * @returns {string} HTML string for the custom checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'N')
                return ''; // Return empty if value is not 'N'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return HTML for approval buttons
        }

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
            height: screen.width < 820 ? 405 : 0, // Set height based on screen width
            columns: [
                // Column definitions
                {
                    id: 'ActionTittle', // Column ID
                    header: _('Acción'), // Column header with localization
                    width: 90, // Column width
                    height: 25, // Column height
                    tooltip: _('Acción'), // Tooltip for the column
                    template: function (obj) {
                        // Template function for rendering actions
                        var action = ''; // Initialize action variable
                        if (devConfig.getPermAction('machineRegisterPay', 'Pay')) {
                            // Check permission for Pay action
                            action =
                                "<span placeholder='Pagar' class='webix_icon wxi-close pay prm-machineRegisterPay'></span>"; // Add Pay icon
                        }
                        if (devConfig.getPermAction('machineRegisterUpdate', 'Update')) {
                            // Check permission for Update action
                            action += "<span class='webix_icon wxi-close update prm-machineRegisterUpdate'></span>"; // Add Update icon
                        }
                        if (devConfig.getPermAction('machineRegisterCommands', 'Commands')) {
                            // Check permission for Commands action
                            action += "<span class='webix_icon wxi-close commands prm-machineRegisterCommands'></span>"; // Add Commands icon
                        }
                        return action; // Return the constructed action HTML
                    },
                },
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip for the column
                    template: function (obj) {
                        // Template function for rendering details icon
                        return "<span class='webix_icon wxi-close details'>"; // Return details icon HTML
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Name', header: _('Nombre'), width: 200, sort: 'int' }, // Name column with localization
                {
                    id: 'AmountBetting', // Column ID
                    header: _('Saldo Juego'), // Column header with localization
                    width: 200, // Column width
                    sort: 'int', // Sort type
                    format: webix.i18n.priceFormat, // Format for displaying prices
                    exportType: 'number', // Export type for this column
                },
                {
                    id: 'RegionName', // Column ID
                    header: _('Región'), // Column header with localization
                    width: 150, // Column width
                    sort: 'int', // Sort type
                },
                {
                    id: 'DepartmentName', // Column ID
                    header: _('Departamento'), // Column header with localization
                    width: 150, // Column width
                    sort: 'int', // Sort type
                },
                {
                    id: 'CityName', // Column ID
                    header: _('Ciudad'), // Column header with localization
                    width: 150, // Column width
                    sort: 'int', // Sort type
                },
                {
                    id: 'CurrencyId', // Column ID
                    header: _('Moneda'), // Column header with localization
                    width: 100, // Column width
                    sort: 'int', // Sort type
                },
                {
                    id: 'Address', // Column ID
                    header: _('Dirección'), // Column header with localization
                    width: 150, // Column width
                    sort: 'int', // Sort type
                },
                {
                    id: 'CreatedDate', // Column ID
                    header: _('Fecha de Creación'), // Column header with localization
                    fillspace: 0, // Fill space option
                    minWidth: 0, // Minimum width
                    width: 180, // Column width
                    sort: 'text', // Sort type
                    format: dateFormat, // Date format for display
                },
                {
                    id: 'LastLoginDateLabel', // Column ID
                    header: _('Fecha de ultimo login'), // Column header with localization
                    fillspace: 0, // Fill space option
                    minWidth: 0, // Minimum width
                    width: 180, // Column width
                    sort: 'text', // Sort type
                    format: dateFormat, // Date format for display
                },
                {
                    id: 'ModifiedLocal', // Column ID
                    header: _('Modificado'), // Column header with localization
                    width: 150, // Column width
                    sort: 'int', // Sort type
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Handler for details icon click
                    vthis.show('machine.machineManagement?user=' + id + '/machine.information'); // Show machine management view
                },
                pay: function (euv, id) {
                    // Handler for pay icon click
                    var vvthis = this; // Reference to the current instance
                    var item = vvthis.getItem(id); // Get the clicked item
                    console.log(item); // Log the item details
                    webix
                        .ui({
                            // Create a modal window for payment
                            view: 'window',
                            head: _('Recargar Máquina ') + item.Name, // Window header
                            id: 'windowTransfers', // Window ID
                            modal: true, // Modal window
                            position: 'center', // Center position
                            body: {
                                // Window body
                                view: 'form',
                                id: 'windowTransfersForm', // Form ID
                                elements: [
                                    // Form elements
                                    {
                                        view: 'text', // Text input for amount
                                        label: _('Monto'), // Label with localization
                                        name: 'amount', // Input name
                                        id: 'amount', // Input ID
                                    },
                                    {
                                        cols: [
                                            // Button layout
                                            {
                                                view: 'button', // Button for recharge
                                                value: _('Recargar'), // Button label
                                                click: function (elementId, event) {
                                                    // Button click handler
                                                    var values = $$('windowTransfersForm').getValues(); // Get form values
                                                    var tthis = this; // Reference to the current instance
                                                    webix
                                                        .ajax() // AJAX request for making transfer
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Agent/MakeAgentTransfers', // API endpoint
                                                            '{ "Id":' +
                                                                item.Id +
                                                                ',"Amount":' +
                                                                values.amount +
                                                                ',"Type":1}', // Request body
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message(_('Error! ')); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    var data = JSON.parse(text); // Parse response
                                                                    if (data.HasError) {
                                                                        // Check for errors
                                                                        webix.message(
                                                                            _(
                                                                                'No Se ha realizado la transferencia. Comunicarse con soporte. ',
                                                                            ),
                                                                        ); // Show error message
                                                                        tthis.getTopParentView().hide(); // Hide window
                                                                    } else {
                                                                        console.log(data); // Log response data
                                                                        webix.message(
                                                                            _(
                                                                                'Se ha realizado la transferencia satisfactoriamente. ',
                                                                            ),
                                                                        ); // Show success message
                                                                        tthis.getTopParentView().hide(); // Hide window
                                                                        webix
                                                                            .ui({
                                                                                // Create a window for invoice
                                                                                view: 'window',
                                                                                width: 500, // Window width
                                                                                height: 700, // Window height
                                                                                head: {
                                                                                    // Window header
                                                                                    view: 'toolbar',
                                                                                    cols: [
                                                                                        {
                                                                                            view: 'label',
                                                                                            label: _('Factura'), // Invoice label
                                                                                        },
                                                                                        {
                                                                                            view: 'button', // Close button
                                                                                            label: 'X',
                                                                                            width: 100,
                                                                                            align: 'right',
                                                                                            click: "$$('windowfact2').close();", // Close action
                                                                                        },
                                                                                    ],
                                                                                },
                                                                                id: 'windowfact2', // Window ID
                                                                                modal: true, // Modal window
                                                                                position: 'center', // Center position
                                                                                body: {
                                                                                    // Window body
                                                                                    rows: [
                                                                                        {
                                                                                            template:
                                                                                                '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                        },
                                                                                    ],
                                                                                },
                                                                            })
                                                                            .show(); // Show invoice window
                                                                        var reader = new FileReader(); // File reader for PDF
                                                                        reader.onload = function (event) {
                                                                            // On load handler
                                                                            $$('pdf').clear(); // Clear previous PDF
                                                                            $$('pdf').parse({
                                                                                // Parse new PDF data
                                                                                data: event.target.result,
                                                                            });
                                                                        };
                                                                        /**
                                                                         * Converts base64 string to Blob.
                                                                         * @param {string} b64Data - Base64 data string.
                                                                         * @param {string} contentType - Content type of the blob.
                                                                         * @param {number} sliceSize - Size of each slice.
                                                                         * @returns {Blob} The created Blob object.
                                                                         */
                                                                        function b64toBlob(
                                                                            b64Data,
                                                                            contentType,
                                                                            sliceSize,
                                                                        ) {
                                                                            contentType = contentType || ''; // Default content type
                                                                            sliceSize = sliceSize || 512; // Default slice size
                                                                            var byteCharacters = atob(b64Data); // Decode base64 string
                                                                            var byteArrays = []; // Array to hold byte arrays
                                                                            for (
                                                                                var offset = 0;
                                                                                offset < byteCharacters.length;
                                                                                offset += sliceSize
                                                                            ) {
                                                                                // Loop through byte characters
                                                                                var slice = byteCharacters.slice(
                                                                                    offset,
                                                                                    offset + sliceSize,
                                                                                ); // Get slice of byte characters
                                                                                var byteNumbers = new Array(
                                                                                    slice.length,
                                                                                ); // Create array for byte numbers
                                                                                for (var i = 0; i < slice.length; i++) {
                                                                                    // Loop through slice
                                                                                    byteNumbers[i] =
                                                                                        slice.charCodeAt(i); // Get char code
                                                                                }
                                                                                var byteArray = new Uint8Array(
                                                                                    byteNumbers,
                                                                                ); // Create Uint8Array from byte numbers
                                                                                byteArrays.push(byteArray); // Push byte array to arrays
                                                                            }
                                                                            var blob = new Blob(byteArrays, {
                                                                                type: contentType,
                                                                            }); // Create Blob from byte arrays
                                                                            return blob; // Return the created Blob
                                                                        }
                                                                        var contentType = 'application/pdf'; // PDF content type
                                                                        var b64Data = data.Pdf; // Base64 PDF data
                                                                        var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                                        var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                                        console.log(blob); // Log Blob
                                                                        document.querySelector('iframe').src = file; // Set iframe source to Blob URL
                                                                        var printWindow = window.open(
                                                                            file,
                                                                            '',
                                                                            'width=800,height=500',
                                                                        ); // Open print window
                                                                        printWindow.print(); // Print the document
                                                                    }
                                                                },
                                                            },
                                                        );
                                                },
                                            },
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'), // Button label
                                                click: function (elementId, event) {
                                                    // Click handler
                                                    this.getTopParentView().hide(); // Hide window
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            move: true, // Allow window movement
                        })
                        .show(); // Show the window
                },
                update: function (euv, id) {
                    // Handler for update icon click
                    var vvthis = this; // Reference to the current instance
                    var item = vvthis.getItem(id); // Get the clicked item
                    console.log(item); // Log the item details
                    webix
                        .modalbox({
                            // Create a modal box for update options
                            id: 'modalAgent',
                            title: _('¿ Qué desea realizar ?'), // Modal title
                            buttons: [
                                _('Actualizar Máquina'), // Update machine button
                                _('Actualizar Versión'), // Update version button
                                _('Ambos'), // Both options button
                                _('Cancelar'), // Cancel button
                            ],
                            text: '', // Modal text
                            width: 500, // Modal width
                        })
                        .then(function (result) {
                            // Handle modal result
                            switch (result) {
                                case '0': // Update machine option
                                    webix
                                        .ui({
                                            // Create a window for machine update
                                            view: 'window',
                                            head: _('Actualizar Máquina ') + item.Name, // Window header
                                            id: 'windowTransfers', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                // Window body
                                                view: 'form',
                                                id: 'windowTransfersForm', // Form ID
                                                elements: [
                                                    // Form elements
                                                    {
                                                        view: 'uploader', // Uploader for file upload
                                                        upload: devConfig.geturlApi() + 'Machine/UpdateMachine', // Upload endpoint
                                                        id: 'AddFile', // Uploader ID
                                                        name: 'AddFile', // Uploader name
                                                        value: _('Agregar Archivo'), // Uploader label
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            // Form data to send with upload
                                                            userid: 123,
                                                            document: 'attachment',
                                                        },
                                                    },
                                                    {
                                                        cols: [
                                                            // Button layout
                                                            {
                                                                view: 'button', // Update button
                                                                value: _('Actualizar'), // Button label
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    if (
                                                                        Object.keys($$('AddFile').files.data.pull)
                                                                            .length > 0
                                                                    ) {
                                                                        // Check if files are selected
                                                                        $$('AddFile').config.formData.Id = item.Id; // Set item ID in form data
                                                                        $$('AddFile').config.formData.Type = 0; // Set type in form data
                                                                        $$('AddFile').send(function (response) {
                                                                            // Send upload request
                                                                            if (!response.HasError) {
                                                                                // Check for errors
                                                                                webix.message(
                                                                                    'Se ha realizado la Actualización satisfactoriamente.',
                                                                                ); // Show success message
                                                                            } else {
                                                                                webix.message({
                                                                                    // Show error message
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ),
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                });
                                                                                this.getTopParentView().hide(); // Hide window
                                                                            }
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            // Show error message for no file
                                                                            text: _('Agregar Archivo'),
                                                                            title: _('¡Error!'),
                                                                            type: 'alert-error',
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                            {
                                                                view: 'button', // Cancel button
                                                                value: _('Cancelar'), // Button label
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    this.getTopParentView().hide(); // Hide window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            move: true, // Allow window movement
                                        })
                                        .show(); // Show the window
                                    break;
                                case '1': // Update version option
                                    webix
                                        .ui({
                                            // Create a window for version update
                                            view: 'window',
                                            head: _('Actualizar Versión ') + item.Name, // Window header
                                            id: 'windowTransfers', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                // Window body
                                                view: 'form',
                                                id: 'windowTransfersForm', // Form ID
                                                elements: [
                                                    // Form elements
                                                    {
                                                        view: 'uploader', // Uploader for file upload
                                                        upload: devConfig.geturlApi() + 'Machine/UpdateVersion', // Upload endpoint
                                                        id: 'AddFile1', // Uploader ID
                                                        name: 'AddFile1', // Uploader name
                                                        value: _('Agregar Archivo'), // Uploader label
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            // Form data to send with upload
                                                            userid: 123,
                                                            document: 'attachment',
                                                        },
                                                    },
                                                    {
                                                        cols: [
                                                            // Button layout
                                                            {
                                                                view: 'button', // Update button
                                                                value: _('Actualizar'), // Button label
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    if (
                                                                        Object.keys($$('AddFile1').files.data.pull)
                                                                            .length > 0
                                                                    ) {
                                                                        // Check if files are selected
                                                                        $$('AddFile1').config.formData.Id = item.Id; // Set item ID in form data
                                                                        $$('AddFile1').config.formData.Type = 1; // Set type in form data
                                                                        $$('AddFile1').send(function (response) {
                                                                            // Send upload request
                                                                            if (!response.HasError) {
                                                                                // Check for errors
                                                                                webix.message(
                                                                                    'Se ha realizado la Actualización satisfactoriamente.',
                                                                                ); // Show success message
                                                                            } else {
                                                                                webix.message({
                                                                                    // Show error message
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ),
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                });
                                                                                this.getTopParentView().hide(); // Hide window
                                                                            }
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            // Show error message for no file
                                                                            text: _('Agregar Archivo'),
                                                                            title: _('¡Error!'),
                                                                            type: 'alert-error',
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                            {
                                                                view: 'button', // Cancel button
                                                                value: _('Cancelar'), // Button label
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    this.getTopParentView().hide(); // Hide window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            move: true, // Allow window movement
                                        })
                                        .show(); // Show the window
                                    break;
                                case '2': // Update both option
                                    webix
                                        .ui({
                                            // Create a window for updating both
                                            view: 'window',
                                            head: _('Actualizar Ambos ') + item.Name, // Window header
                                            id: 'windowTransfers', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                // Window body
                                                view: 'form',
                                                id: 'windowTransfersForm', // Form ID
                                                elements: [
                                                    // Form elements
                                                    {
                                                        view: 'uploader', // Uploader for file upload
                                                        upload: devConfig.geturlApi() + 'Machine/UpdateTwo', // Upload endpoint
                                                        id: 'AddFile2', // Uploader ID
                                                        name: 'AddFile2', // Uploader name
                                                        value: _('Agregar Archivo'), // Uploader label
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            // Form data to send with upload
                                                            userid: 123,
                                                            document: 'attachment',
                                                        },
                                                    },
                                                    {
                                                        cols: [
                                                            // Button layout
                                                            {
                                                                view: 'button', // Update button
                                                                value: _('Actualizar'), // Button label
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    if (
                                                                        Object.keys($$('AddFile2').files.data.pull)
                                                                            .length > 0
                                                                    ) {
                                                                        // Check if files are selected
                                                                        $$('AddFile2').config.formData.Id = item.Id; // Set item ID in form data
                                                                        $$('AddFile2').config.formData.Type = 2; // Set type in form data
                                                                        $$('AddFile2').send(function (response) {
                                                                            // Send upload request
                                                                            if (!response.HasError) {
                                                                                // Check for errors
                                                                                webix.message(
                                                                                    'Se ha realizado la Actualización satisfactoriamente.',
                                                                                ); // Show success message
                                                                            } else {
                                                                                webix.message({
                                                                                    // Show error message
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ),
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                });
                                                                                this.getTopParentView().hide(); // Hide window
                                                                            }
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            // Show error message for no file
                                                                            text: _('Agregar Archivo'),
                                                                            title: _('¡Error!'),
                                                                            type: 'alert-error',
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                            {
                                                                view: 'button', // Cancel button
                                                                value: _('Cancelar'), // Button label
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    this.getTopParentView().hide(); // Hide window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            move: true, // Allow window movement
                                        })
                                        .show(); // Show the window
                                    break;
                                case '3': // Cancel option
                                    break; // Do nothing
                            }
                        });
                },
                commands: function (euv, id) {
                    // Handler for commands icon click
                    var vvthis = this; // Reference to the current instance
                    var item = vvthis.getItem(id); // Get the clicked item
                    console.log(item); // Log the item details
                    webix
                        .ui({
                            // Create a window for sending commands
                            view: 'window',
                            head: _('Enviar Comando a ') + item.Name, // Window header
                            id: 'windowTransfers', // Window ID
                            modal: true, // Modal window
                            position: 'center', // Center position
                            body: {
                                // Window body
                                view: 'form',
                                id: 'windowTransfersForm', // Form ID
                                elements: [
                                    // Form elements
                                    {
                                        view: 'text', // Text input for command
                                        label: _('Comando'), // Label with localization
                                        name: 'Command', // Input name
                                        id: 'Command', // Input ID
                                    },
                                    {
                                        cols: [
                                            // Button layout
                                            {
                                                view: 'button', // Send button
                                                value: _('Enviar'), // Button label
                                                click: function (elementId, event) {
                                                    // Click handler
                                                    var values = $$('windowTransfersForm').getValues(); // Get form values
                                                    var tthis = this; // Reference to the current instance
                                                    webix
                                                        .ajax() // AJAX request for sending command
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Machine/sendCommand', // API endpoint
                                                            '{ "Id":' +
                                                                item.Id +
                                                                ',"Command":"' +
                                                                values.Command +
                                                                '"}', // Request body
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message(_('Error! ')); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    var data = JSON.parse(text); // Parse response
                                                                    if (data.HasError) {
                                                                        // Check for errors
                                                                        webix.message(
                                                                            _(
                                                                                'No Se ha enviado el comando. Comunicarse con soporte. ',
                                                                            ),
                                                                        ); // Show error message
                                                                        tthis.getTopParentView().hide(); // Hide window
                                                                    } else {
                                                                        webix.message(
                                                                            _(
                                                                                'Se ha enviado el comando satisfactoriamente. ',
                                                                            ),
                                                                        ); // Show success message
                                                                        tthis.getTopParentView().hide(); // Hide window
                                                                    }
                                                                },
                                                            },
                                                        );
                                                },
                                            },
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'), // Button label
                                                click: function (elementId, event) {
                                                    // Click handler
                                                    this.getTopParentView().hide(); // Hide window
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            move: true, // Allow window movement
                        })
                        .show(); // Show the window
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'BetShop/GetMachines', // Data URL
            data2: [
                // Sample data for the datatable
                {
                    id: '332',
                    Name: 'Punto 1',
                    Email: 'asd@gmail.com',
                    RegionName: 'Colombia',
                    DepartmentName: 'Antioquia',
                    CityName: 'Medellin',
                    CurrencyId: 'PES',
                    Phone: '3334455',
                    Andress: 'CLL 4 # 45 - 78',
                    CreatedDate: '2018',
                    LastLoginDateLabel: '2019',
                    ModifiedLocal: 'Administrador General',
                },
            ],
            on: {
                // Event handlers for datatable
                onItemDblClick: (id) => {
                    // Handler for double-click event
                    vthis.show('machine.machineManagement?user=' + id + '/machine.information'); // Show machine management view
                },
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Get the data URL
        var filter = ''; // Initialize filter variable
        this.on(this.app, 'machineRegister:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Loop through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Loop through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
